import { createApp } from "vue";
import App from "./App.vue";
import { bootstrap } from "./cool";
import "./cool/utils/number";
import createI18n from "./modules/i18n";
// import getLanguage from "./utils/lang";
import I18NextVue from "i18next-vue";
import { getLangHost } from "/@/cool/config/oss";
import { getOem } from "/@//utils/oem";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { registerTransferValue } from "./cool/utils/ext_string";
import { getOemSetting } from "/@/utils/oem";
import { ElMessageBox } from "element-plus";
import { versionPolling } from "./version";
import storage from "./cool/utils/storage";
// 导入自定义指令
// @ts-expect-error - 指令文件类型声明
import disableTableContextMenu from "./directives/disableTableContextMenu";

// 扩展 Window 接口类型
declare global {
	interface Window {
		__DISABLE_TABLE_CONTEXT_MENU__?: boolean;
	}
}

dayjs.extend(utc);
dayjs.extend(timezone);

const app = createApp(App);

// 注册全局指令
app.directive("disable-table-contextmenu", disableTableContextMenu);

// 🔥 全局禁用 cool admin 表格右键菜单
// 方法1: 设置全局标志，在 helper.tsx 中会检查此标志
window.__DISABLE_TABLE_CONTEXT_MENU__ = true;

// 方法2: DOM 层面阻止所有 el-table 和 cl-table 的右键事件（双重保险）
app.mixin({
	mounted() {
		// 使用 nextTick 确保 DOM 已渲染
		this.$nextTick(() => {
			// 阻止所有 el-table 的右键菜单
			const tables = document.querySelectorAll(".el-table, .cl-table");
			tables.forEach((table) => {
				table.addEventListener("contextmenu", (e) => e.preventDefault(), { capture: true });
			});
		});
	},
	updated() {
		// 动态添加的表格也需要处理
		this.$nextTick(() => {
			const tables = document.querySelectorAll(".el-table, .cl-table");
			tables.forEach((table) => {
				// 避免重复添加监听器
				if (!(table as any).__contextMenuDisabled) {
					table.addEventListener("contextmenu", (e) => e.preventDefault(), {
						capture: true
					});
					(table as any).__contextMenuDisabled = true;
				}
			});
		});
	}
});

// 方法3: 全局监听，处理后续动态创建的表格
if (typeof window !== "undefined") {
	// 使用事件委托，捕获阶段阻止所有表格的右键事件
	document.addEventListener(
		"contextmenu",
		(e) => {
			const target = e.target as HTMLElement;
			// 检查是否在表格内
			if (target.closest(".el-table, .cl-table")) {
				e.preventDefault();
				e.stopPropagation();
			}
		},
		{ capture: true }
	);
}

// 启动
bootstrap(app)
	.then(async () => {
		// 加载数据
		// const langExtraResp: any = await getLanguage();
		//获取 OEM 对应的配置
		await getOem();
		//插入 Link icon
		const favicon = getOemSetting("favicon");
		const domain = getOemSetting("domain");
		let langExtraResp;

		if (isDevHost(domain)) {
			langExtraResp = getLangHost() + "/" + getOemSetting("multilang");
		} else {
			langExtraResp = "https://" + domain + "/" + getOemSetting("multilang");
		}

		localStorage.setItem(`${domain}`, getOemSetting("id"));

		fetch(langExtraResp)
			.then((response) => response.json())
			.then((data) => {
				const i18n = createI18n(data);
				app.use(I18NextVue, { i18next: i18n }).mount("#app");
			})
			.catch((error) => {
				console.error(error);
			});

		storage.set("favicon", favicon);
		if (favicon) {
			const link = document.createElement("link");
			link.rel = "icon";
			link.href = favicon;
			document.head.appendChild(link);
		}
		// const i18n = createI18n(langExtraResp);
		registerTransferValue(app);

		versionPolling();
	})
	.catch((err) => {
		ElMessageBox.alert(err.message);
		console.error("平台 启动失败", err);
	});

function isDevHost(domain: string) {
	return ["localhost", "dev", "127", "shop.local"].some((item) => domain.includes(item));
}
